<template>
  <div class="page-shell">
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
      </v-card>

      <v-tabs v-model="tab" class="page-tabs">
        <v-tab
          v-for="item in items"
          :key="item.tab"
          v-show="getUser.nivel <= item.nivel"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <b-container fluid>
            <b-row>
              <b-col cols="6">
                <v-btn
                  class="ma-2"
                  x-large
                  dark
                  color="grey darken-4"
                  @click="NovoPedido"
                  text
                >
                  <v-icon>mdi-plus</v-icon>
                  Novo Pedido
                </v-btn>
              </b-col>
              <b-col cols="6" :style="{ marginTop: '15px' }">
                <v-text-field
                  placeholder="Filtro"
                  v-model="filtraPedidos"
                  solo
                  clearable
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details="auto"
                  class="input-search"
                ></v-text-field>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="4" v-for="_file in files_pedidos" :key="_file.id">
                <v-card
                  :style="{
                    width: '100%',
                    paddingTop: '10px',
                    marginBottom: '15px',
                    background: 'rgb(6, 200, 247)',
                    background:
                      'linear-gradient(0deg,rgb(199, 199, 199) 10%,rgb(190, 190, 190) 60%,rgb(199, 199, 199)) 70%',
                  }"
                >
                  <b-container fluid>
                    <b-row @dblclick="editPedido(_file)">
                      <b-col cols="11">
                        <b-row>
                          <b-col cols="12">
                            {{
                              trataNULL(_file.nome, "", "") +
                              trataNULL(_file.cnpj, "", " - ")
                            }}
                            <br />
                            {{
                              trataNULL(_file.nome_cid, "", "") +
                              trataNULL(_file.uf, "", ", ")
                            }}
                            <br />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12">
                            <div>
                              {{ trataNULL(_file.fone, "Sem Fone", "") }} <br />
                              {{ trataNULL(_file.fone2, "Sem Fone 2", " - ") }}
                              <br />

                              {{
                                trataNULL(
                                  _file.email,
                                  "Email não informado",
                                  ""
                                )
                              }}
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col
                        cols="1"
                        :style="{
                          position: 'absolute',
                          top: '1px',
                          right: '15px',
                        }"
                      >
                        <v-btn
                          icon
                          color="grey darken-4"
                          @click="CadastrarCliente(_file)"
                        >
                          <v-icon small>mdi-account-check</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="green darken-4"
                          @click="ImpPedido(_file)"
                        >
                          <v-icon small>mdi-printer</v-icon></v-btn
                        >
                        <v-btn
                          icon
                          color="red darken-4"
                          @click="excluirPedido(_file)"
                        >
                          <v-icon small>mdi-trash-can</v-icon>
                        </v-btn>
                      </b-col>
                    </b-row>
                  </b-container>
                </v-card>
              </b-col>
            </b-row>
          </b-container>
        </v-tab-item>
      </v-tabs-items>
    </v-list>

    <v-dialog
      v-model="modal_pedido"
      max-width="1200"
      scrollable
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10"> Pedido </b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_pedido = false" text icon x-large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text style="max-height: 700px">
          <b-container fluid>
            <br />
            <b-row>
              <b-col cols="5">
                <v-text-field
                  label="Nome fantasia"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.nome"
                  :value="pedido.nome"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field
                  label="Razão Social"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.razao"
                  :value="pedido.razao"
                  hide-details="auto"
                  maxlength="50"
                ></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="CNPJ/CPF"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.cnpj"
                  hide-details="auto"
                  maxlength="30"
                  :value="pedido.cnpj"
                  v-mask="['###.###.###-##', '##.###.###-####/##']"
                ></v-text-field
              ></b-col>
              <b-col cols="3">
                <v-text-field
                  label="Insc. Est"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.insc_est"
                  :value="pedido.insc_est"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="Contato"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.contato"
                  :value="pedido.contato"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="CEP"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.cep"
                  hide-details="auto"
                  maxlength="10"
                  :value="pedido.cep"
                  v-mask="['#####-###']"
                ></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field
                  label="Rua/Avenida/Logradouro"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.endereco"
                  :value="pedido.endereco"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
              <b-col cols="2">
                <v-text-field
                  label="Número"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.numero"
                  :value="pedido.numero"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="Bairro"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.bairro"
                  :value="pedido.bairro"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
              <b-col cols="3">
                <v-text-field
                  label="Complemento"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.complemento"
                  :value="pedido.complemento"
                  hide-details="auto"
                ></v-text-field
              ></b-col>
              <b-col cols="6"
                ><AutoBusca
                  id="cidade"
                  item_id="codcid"
                  item_text="nome"
                  item_campos="cid.codcid, TRIM(cid.nome)||'-'||cid.uf as nome"
                  item_busca="cid.codcid::text|| '-' || TRIM(UPPER(cid.nome)) "
                  item_left=""
                  tabela="cidade cid"
                  :value="pedido.codcid"
                  @getID="getID"
                  :label="'Digite a cidade'"
                  :rdark="false"
              /></b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field
                  label="Fone"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.fone"
                  hide-details="auto"
                  maxlength="15"
                  :value="pedido.fone"
                  v-mask="['(##)####-####', '(##)#####-####']"
                ></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field
                  label="Fone 2"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.fone2"
                  hide-details="auto"
                  maxlength="15"
                  :value="pedido.fone2"
                  v-mask="['(##)####-####', '(##)#####-####']"
                ></v-text-field>
              </b-col>
              <b-col cols="6">
                <v-text-field
                  label="E-Mail"
                  placeholder="Não informado"
                  outlined
                  v-model="pedido.email"
                  :value="pedido.email"
                  hide-details="auto"
                ></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <small>Observação de pagamento</small>
                <Editor v-model="pedido.obs_pgt" editorStyle="height: 200px">
                </Editor>
              </b-col>
              <b-col cols="6">
                <small>Observação do pedido</small>
                <Editor
                  v-model="pedido.obs_pedido"
                  editorStyle="height: 200px"
                ></Editor>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="SalvarPedido" color="grey darken-4" block dark>
            <v-icon>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import AutoBusca from "../components/AutoBusca.vue";
import Pedidos from "../domain/Pedidos";
import _Enum from "../obj/Enum";
import { mapGetters } from "vuex";
import Editor from "primevue/editor";

export default {
  components: {
    Editor,
    AutoBusca,
  },
  data: () => ({
    Enum: _Enum,
    pedido: {},
    pedidos: [],
    filtro_id_cli: "",
    items: [{ tab: "Pedidos", nivel: 7 }],
    tab: 0,
    oper: "N",
    modal_pedido: false,
    items_menu: [{ id: 0, title: "Excluir" }],
    filtraPedidos: "",
  }),
  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    files_pedidos() {
      let valores = this.pedidos;
      var wbusca = "";
      if (this.filtraPedidos != null)
        wbusca = this.filtraPedidos.toString().toLowerCase();

      if (wbusca != "") {
        var wvalores = valores.filter((item) => {
          if (item.nome == null) item.nome = "";
          if (item.razao == null) item.razao = "";
          return item.razao.toLowerCase().indexOf(wbusca) > -1 ||
            item.nome.toLowerCase().indexOf(wbusca) > -1
            ? item
            : null;
        });
        valores = wvalores;
      } else {
        valores = this.pedidos;
      }

      return valores;
    },
  },
  created() {
    /* if (this.getUser.nivel > 1) {
      this.$router.replace({ name: "restrito" });
    } */
  },
  mounted() {
    //this.NovoPedido();
    this.buscaPedidos();
  },
  methods: {
    getID(val) {
      if (val.id == "cliente") {
        if (val.value != null && val.value != "") {
          this.filtro_id_cli = val.value;
        } else {
          this.NovoPedido();
        }
      }

      if (val.id == "cidade") {
        if (val.value != null && val.value != "") {
          this.pedido.codcid = val.value;
        }
      }
    },

    buscaPedidos() {
      Vue.Loading("", "", this);
      this.service = new Pedidos(this.$resource);
      this.service.getAll().then(
        function (tmp) {
          Vue.CloseLoading(this);
          this.pedidos = tmp;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    editPedido(file) {
      this.oper = "U";
      this.pedido = JSON.parse(JSON.stringify(file));
      this.pedido.obs_pgt = Vue.atob(this.pedido.obs_pgt);
      this.pedido.obs_pedido = Vue.atob(this.pedido.obs_pedido);
      this.modal_pedido = true;
    },

    ImpPedido(file) {
      Vue.Loading("", "", this);
      this.service = new Pedidos(this.$resource);
      this.service.getPedidoImpressao(file.id).then(
        function (ret) {
          Vue.impRel("Pedido", ret);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },
    CadastrarCliente(file) {
      var vm = this;
      Vue.Pergunta(
        vm,
        "Cadastrar cliente",
        "Deseja cadastrar o cliente e fechar o pedido?",
        function () {
          vm.CadastrarCliente2(file);
        },
        null
      );
    },

    CadastrarCliente2(file) {
      Vue.Loading("", "", this);
      this.service = new Pedidos(this.$resource);
      this.service.up(file.id).then(
        function () {
          Vue.CloseLoading(this);
          this.buscaPedidos();
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },

    testaMenu(pedido, menu) {
      // this.file = chamado;

      if (menu.id == 0) {
        this.excluirPedido(pedido);
      }
    },

    NovoPedido() {
      this.pedido = this.getTmpPedido();
      this.pedido.id = "";
      this.filtro_id_cli = null;
      this.modal_pedido = true;
    },

    excluirPedido(file) {
      var vm = this;
      Vue.Pergunta(
        vm,
        "Deseja excluir pedido",
        "Realmente quer exclui o pedido?",
        function () {
          vm.excluirPedido2(file);
        },
        null
      );
      //(vm, title, content, callSim, callNao)
    },

    excluirPedido2(file) {
      Vue.Loading("", "", this);
      this.service = new Pedidos(this.$resource);
      this.service.del(file.id).then(
        function () {
          Vue.CloseLoading(this);
          this.buscaPedidos();
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },

    SalvarPedido() {
      var _cli = JSON.parse(JSON.stringify(this.pedido));
      if (_cli.nome == "" || _cli.nome == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.razao == "" || _cli.razao == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.cnpj == "" || _cli.cnpj == null) {
        Vue.Mensagem(this, "Campo inválido", "CNPJ precisa ser preenchido");
        return;
      }

      if (_cli.codcid == "" || _cli.codcid == null) {
        Vue.Mensagem(this, "Campo inválido", "Cidade deve ser preenchida");
        return;
      }

      _cli.obs_pgt = Vue.btoa(_cli.obs_pgt);
      _cli.obs_pedido = Vue.btoa(_cli.obs_pedido);
      var dados = [_cli];
      Vue.Loading("", "", this);
      this.service = new Pedidos(this.$resource);
      this.service.save(dados).then(
        function () {
          Vue.CloseLoading(this);
          this.modal_pedido = false;
          this.buscaPedidos();
          //this.NovoPedido();
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },

    getTmpPedido() {
      return {
        id: "",
        nome: "",
        razao: "",
        cnpj: "",
        insc_est: "",
        cep: "",
        endereco: "",
        numero: "",
        bairro: "",
        complemento: "",
        codcid: "",
        fone: "",
        fone2: "",
        email: "",
        obs_pgt: "",
        obs_pedido: "",
        contato: "",
      };
    },

    trataNULL(valor, padrao, prefix) {
      return Vue.trataNULL(valor, padrao, prefix);
    },
  },
};
</script>
